import { NgModule, LOCALE_ID }     from '@angular/core';
import { BrowserModule, Title }    from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent }     from './app.component';

import { CoreModule }   from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { WebTemplateModule } from 'src/app/web-template/web-template.module';
import { CampusModule }      from 'src/app/modules/campus/campus.module';
import { EditionModule }     from 'src/app/modules/edition/edition.module';

import { registerLocaleData } from '@angular/common';
import localeES from '@angular/common/locales/es';

registerLocaleData(localeES);

@NgModule({

    declarations: [
        AppComponent
    ],

    imports: [
        AppRoutingModule,
        BrowserModule,
        BrowserAnimationsModule,
        CoreModule,
        SharedModule,
        WebTemplateModule,
        CampusModule,
        EditionModule
    ],

    providers: [
        Title,
        { 
            provide: LOCALE_ID, 
            useValue: 'es-ES' 
        }
    ],

    bootstrap: [
        AppComponent
    ]

})

export class AppModule { }
